import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { faqs } from "@/data/siteContent";

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="section relative">
      <div className="container-luxe grid lg:grid-cols-[0.9fr_1.1fr] gap-14">
        <div className="reveal">
          <div className="text-[11px] tracking-[0.4em] uppercase text-gold-light">
            FAQ · प्रश्न
          </div>
          <h2
            data-testid="faq-title"
            className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1.05] text-cream"
          >
            Questions,{" "}
            <span className="italic font-editorial gold-text">answered</span>.
          </h2>
          <p className="mt-5 text-cream-muted max-w-md">
            Everything you may wonder before your first sitting with Jyotish
            ji. Have another question? Reach out through the contact form
            below.
          </p>
        </div>

        <div className="reveal">
          <Accordion
            type="single"
            collapsible
            className="w-full space-y-3"
            data-testid="faq-accordion"
          >
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="glass rounded-xl border-white/5 px-6 data-[state=open]:border-[#D4AF37]/40 transition-colors duration-500"
              >
                <AccordionTrigger className="text-left font-display text-cream hover:no-underline text-[15px] tracking-wide py-5 [&[data-state=open]>svg]:text-gold">
                  <span className="font-devanagari">{f.q}</span>
                </AccordionTrigger>
                <AccordionContent className="text-cream-muted text-[14px] leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
